export const nFirstItems = <T>(arr: T[], n: number) => arr.slice(0, n)
